With my current organisation goal of "{{goalName}}",
my current measurement is: {{currentMeasurement}}, and I am trying to achieve {{targetMeasurement}}.
Generate a description for this goal with not more than {{maxLength}} characters, outlines the desired outcomes and objectives,
identify the gaps, identify what we need to do to bridge the gaps and what is our approach to achieving success.
